import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import useTokenStore from "store/tokenStore";
import { deleteEmptyObjects } from "utils";

const useUpdateConfig = (configId) => {
	const { accessToken } = useTokenStore();
	const queryClient = useQueryClient();

	const updateConfig = async (data) => {
		const instance = await InitApi({ accessToken });

		const payload = deleteEmptyObjects(data);
		const response = await instance.patch(
			`/configurations/${configId}`,
			payload
		);
		await queryClient.invalidateQueries("configs");
		return response.data;
	};

	return useMutation(updateConfig, {
		onSuccess: async (data) => {
			toast.success(data.message);
		},
		onError: async (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{
					className: "max-w-max",
				}
			);
		},
	});
};

export default useUpdateConfig;
